<template>
  <section class="blog-area ptb-70">
    <div class="container">
      <div class="row">
      <template v-for="post in posts">
        <div class="col-lg-4 col-md-6" :key="post.id">
          <div class="single-blog-post">
            <div class="blog-image">
              <router-link :to="'/blog/'+post.id">
                <img :src="post.image" alt="image" />
              </router-link>

              <div class="date">
                <i class="far fa-calendar-alt"></i> {{post.date}}
              </div>
            </div>

            <div class="blog-post-content">
              <h3>
                <router-link :to="'/blog/'+post.id">{{post.title}}</router-link>
              </h3>

              <span>
                by
                {{post.author}}
              </span>

              <p>{{post.body | shorten}}</p>

              <router-link :to="'/blog/'+post.id" class="read-more-btn">
                Read More
                <i class="fas fa-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>
      </template>

        <!-- <div class="col-lg-12 col-md-12">
          <div class="pagination-area">
            <a href="blog-1.html#" class="prev page-numbers">
              <i class="fas fa-angle-double-left"></i>
            </a>
            <a href="blog-1.html#" class="page-numbers">1</a>
            <span class="page-numbers current" aria-current="page">2</span>
            <a href="blog-1.html#" class="page-numbers">3</a>
            <a href="blog-1.html#" class="page-numbers">4</a>
            <a href="blog-1.html#" class="next page-numbers">
              <i class="fas fa-angle-double-right"></i>
            </a>
          </div>
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      posts: null
    };
  },
  mounted() {
    this.posts = this.$store.getters.getPost;
  },
  filters: {
    shorten: value => {
      return value.substr(0,160);
    }
  }
};
</script>